<template>
    <div>
        <svg
            viewBox="0 0 67 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="67"
            height="85"
            class="overflow-visible transition-transform duration-300 group-hover/menuItem:scale-125">
            <path
                d="M24.1144 35.232C23.6714 35.3449 23.3613 35.7438 23.3613 36.201L23.3613 48.7988C23.3613 49.256 23.6714 49.6549 24.1144 49.7678L64.4664 60.0484C65.0986 60.2095 65.7133 59.7318 65.7133 59.0794L65.7133 50.1599L65.7133 34.84L65.7133 25.9204C65.7133 25.268 65.0986 24.7903 64.4664 24.9514L24.1144 35.232Z"
                stroke="currentColor"
                stroke-width="2"
                fill="transparent"
                class="transition-transform delay-[400ms] duration-300 group-hover/menuItem:translate-x-3 group-hover/menuItem:fill-white" />
            <path
                d="M42.7029 11.8848C43.146 11.9977 43.456 12.3967 43.456 12.8539L43.4561 25.4516C43.4561 25.9088 43.146 26.3078 42.7029 26.4207L2.351 36.7013C1.71877 36.8624 1.10411 36.3847 1.10411 35.7322L1.10411 26.8127L1.10411 11.4928L1.1041 2.57327C1.1041 1.92084 1.71876 1.44315 2.351 1.60422L42.7029 11.8848Z"
                stroke="currentColor"
                stroke-width="2"
                fill="transparent"
                class="transition-transform delay-300 duration-300 group-hover/menuItem:-translate-x-2 group-hover/menuItem:fill-white" />
            <path
                d="M42.7029 58.5806C43.146 58.6935 43.456 59.0925 43.456 59.5497L43.4561 72.1474C43.4561 72.6046 43.146 73.0036 42.7029 73.1165L2.351 83.3971C1.71877 83.5582 1.10411 83.0805 1.10411 82.428L1.10411 73.5085L1.10411 58.1886L1.1041 49.2691C1.1041 48.6166 1.71876 48.1389 2.351 48.3L42.7029 58.5806Z"
                stroke="currentColor"
                stroke-width="2"
                fill="transparent"
                class="transition-transform delay-[500ms] duration-300 group-hover/menuItem:-translate-x-2 group-hover/menuItem:fill-white" />
        </svg>
    </div>
</template>

<script setup lang="ts"></script>
